import { FormattedMessage } from 'react-intl'
import _isEmpty from 'lodash/isEmpty'

import { jobInfoNotesMessages } from '../messages'
import { JobNotesListContainer } from './styles'
import type { JobNoteType } from 'features/jobs/types'
import JobNote from './JobNote'
import { JobNoteBlock } from '../styles'

interface JobNotesListProps {
  jobNotes: JobNoteType[]
}
function JobNotesList({ jobNotes }: JobNotesListProps) {
  return (
    <JobNotesListContainer>
      {_isEmpty(jobNotes) ? (
        <JobNoteBlock>
          <FormattedMessage {...jobInfoNotesMessages.noJobNotesMessage} />
        </JobNoteBlock>
      ) : (
        jobNotes.map((note) => (
          <JobNote key={note.creationDate} jobNote={note} />
        ))
      )}
    </JobNotesListContainer>
  )
}

export default JobNotesList
